// Shared component styles. Preserve selector order, style values, and caller overrides.
export const DEFAULT_BORDER = "#29ABFF";
export const DEFAULT_TITLE = "#3451F4";
export const DEFAULT_ACTION = "#9C4FFF";
export const sectionHeaderStyles = {
  root: ({
    dividerColor,
    sx
  }) => ({
    borderTop: `1px solid ${dividerColor}`,
    borderBottom: `1px solid ${dividerColor}`,
    py: 3,
    mb: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    flexWrap: "nowrap",
    ...sx
  }),
  title: ({
    titleSx
  }) => ({
    fontSize: 20,
    fontWeight: 700,
    color: DEFAULT_TITLE,
    fontFamily: "Be Vietnam Pro",
    lineHeight: "30px",
    flex: 1,
    minWidth: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    ...titleSx
  }),
  action: ({
    actionDisabled,
    actionSx
  }) => ({
    flexShrink: 0,
    minWidth: "auto",
    minHeight: "auto",
    px: 0,
    py: 0,
    textTransform: "none",
    fontSize: 14,
    fontWeight: 400,
    color: actionDisabled ? "#98A2B3" : DEFAULT_ACTION,
    fontFamily: "Be Vietnam Pro",
    lineHeight: "24px",
    letterSpacing: 0,
    "& .MuiButton-startIcon": {
      mr: 0.5
    },
    "&:hover": {
      backgroundColor: "transparent",
      opacity: actionDisabled ? 1 : 0.92
    },
    ...actionSx
  })
};
